import { t } from 'ttag';

import { ADMIN_ID, COLLABORATOR_ID } from './service';

// eslint-disable-next-line import/prefer-default-export
export const ROLE_LABEL = () => ({
  [COLLABORATOR_ID]: t`Collaborator`,
  [ADMIN_ID]: t`Admin`,
});
